// Partner brand colors configuration
export const PARTNER_COLORS: { [key: string]: string } = {
    BJS: '#C92638',      // BJ's
    SAKS: '#000000',     // Saks Fifth Avenue - Black
    NMG: '#000000',      // Neiman Marcus - Black
    KHL: '#800033',      // Kohl's
    WAY: '#7F187F',      // Wayfair - Purple
    MEN: '#FFD13B',      // Menards - Yellow
    WMT: '#0071CE',      // Walmart - Blue
    REI: '#5C8A65',      // REI - Green
    ABH: '#E5883D',      // Aubuchon Hardware - Orange
    CCA: '#064266',      // CCA Global Partners - Blue
    DFS: '#EA4209',      // Discover Financial - Orange
    TMO: '#E20074',      // T-Mobile - Magenta
    WSI: '#000000',      // Williams Sonoma - Black
    // Add more partners with their brand colors
    DEFAULT: '#2C4F6F'   // Default navy blue
};

export const getPartnerColor = (partnerCode: string): string => {
    return PARTNER_COLORS[partnerCode?.toUpperCase()] || PARTNER_COLORS.DEFAULT;
};